<template>
  <el-dialog title="供应商中标" class="global-dialog" :visible.sync="showDlg" width="600px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        ref="form2" :rules="rules" label-width="140px">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="supplierName" label="供应商名称">
              {{ supplierName || '--' }}
            </el-form-item>
          </el-col>
          <!-- <el-col>
            <el-form-item prop="orderType" label="订单类型">
              <el-radio-group v-model="formData.orderType">
                <el-radio label="1">一口价订单</el-radio>
                <el-radio label="2">基差订单</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="purchasePrice" label="一口价/基差价格">
              <el-input-number v-model="formData.purchasePrice" :precision='0' placeholder="请输入价格" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="fileList" label="采购订单合同附件">
              <file-upload v-model="formData.fileList" :maxSize="20"></file-upload>
            </el-form-item>
          </el-col> -->
        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button @click="submitDlg" type="primary">保 存</el-button>
    </span>

  </el-dialog>
</template>
<script>

export default {
  props: {

    showDlg: {
      type: Boolean,
      default: false
    },
    dataInfo: {
      type: Object,
      default: () => { }
    }

  },
  data() {
    return {
      supplierName: '',
      formData: {
        relId: '',
        bidId: '',
        supplierId: ''
        // orderType: '', // 订单类型1一口价订单2基差订单
        // purchasePrice: null, // 基差价格/一口价
        // fileList: []
      },
      loading: false,
      rules: {
        orderType: [{ required: true, message: '请选择订单类型', trigger: ['change', 'blur'] }],
        purchasePrice: [{ required: true, message: '请输入价格', trigger: ['change', 'blur'] }],
        fileList: [{ required: true, message: '请选择上传采购订单合同附件', trigger: ['change', 'blur'] }]
      }

    }
  },
  created() {
    this.supplierName = this.dataInfo.supplierName
    this.formData.relId = this.dataInfo.relId
    this.formData.bidId = this.dataInfo.bidId
    this.formData.supplierId = this.dataInfo.supplierId
  },
  methods: {
    handleClose() {
      this.$emit('update:showDlg', false)
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        console.log(this.formData)
        this.loading = true

        const url = this.$apis.tenderDocument.addYcBidDocument
        this.$axios.post(url, this.formData).then(() => {
          this.$emit('successSave')
          this.handleClose()
        }).finally(() => {
          this.loading = false
        })
      })
    }

  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
